export enum StorefrontCustomerProfilesWorkspaceCapabilityUdoTemplateKey {
    profile = "80b550f2-0b4c-4332-a24b-7a209e9a8bdf",
    address = "e792ca68-f318-4131-a82c-58a9e0cdc17e",
    procurementContact = "5b3e30a1-f84f-45d9-b2c0-850e24f3dd10",
}
